export class TipoExecucao {
    id: string;
    name: string;

    public static get POSFATO() {
        return {id: 'POS_FATO', name: 'Pós-fato'};
    }

    public static get ONLINE() {
        return {id: 'ONLINE', name: 'On-line'};
    }

    public static get getTiposExecucao() {
        return [
            this.POSFATO,
            this.ONLINE
        ];
    }

    public static findTiposExecucao(nome: string): TipoExecucao {
        if (this.ONLINE.id === nome) {
            return this.ONLINE
        }
        return this.POSFATO;
    }
}
